import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';

import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';

@Injectable()
export class MensajesContactoService {
  private mensajesCollection: AngularFirestoreCollection<any> = this.afs.collection<any>('mensajes');

  constructor(public afs: AngularFirestore) { }

  enviarMsj(data:any, userType:string){
    console.log(data, userType);
    let datos:any = {
      "name":data.name || "",
      "lastName":data.lastName || "",
      "secondLastName":data.secondLastName || "",
      "completeName":data.completeName || "",
      "phoneNumber":data.phoneNumber || "",
      "cellPhoneNumber":data.cellPhoneNumber || "",
      "address":data.address || "",
      "email":data.email || "",
      "comments":data.comments || "",
      "userType":userType || "",
      "status":"solicitud",
      "date": new Date()
    };

    console.log(datos, userType);

    return this.mensajesCollection.add(datos);

    //return this.http.post(this.apiUrl, data);
  }

}



// WEBPACK FOOTER //
// /Users/lgh/Documents/apps/editorial/src/app/services/mensajes-contacto.service.ts